import axios from 'axios'
import store from '@/store'
import storage from 'store'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { baseUrl } from '../../env'

const request = axios.create({
  baseURL: baseUrl,
  timeout: 600000
})

let sessionInvalidBarrier = null
let lastSessionStoreNotificationAt = 0

const sessionInvalidReasons = [
  'SESSION_REPLACED',
  'SESSION_EXPIRED',
  'SESSION_UPGRADED',
  'TOKEN_EXPIRED',
  'TOKEN_INVALID'
]

const handleSessionInvalid = data => {
  if (sessionInvalidBarrier) {
    return sessionInvalidBarrier
  }

  // 会话失效属于终止型错误：页面即将重载，后续请求和业务 catch 不应继续执行。
  sessionInvalidBarrier = new Promise(() => {})
  notification.error({
    message: data.reason === 'SESSION_REPLACED' ? '账号已在其他设备登录' : '登录状态已失效',
    description: data.msg || '请重新登录'
  })
  store.dispatch('ClearLocalSession').finally(() => {
    setTimeout(() => {
      window.location.reload()
    }, 1200)
  })
  return sessionInvalidBarrier
}

const handleSessionStoreUnavailable = data => {
  const now = Date.now()
  if (now - lastSessionStoreNotificationAt < 5000) {
    return
  }
  lastSessionStoreNotificationAt = now
  notification.error({
    message: '会话服务暂不可用',
    description: data.msg || '请稍后重试，当前登录状态会保留'
  })
}

const errorHandler = error => {
  if (sessionInvalidBarrier) {
    return sessionInvalidBarrier
  }
  if (!error || !error.response) {
    return Promise.reject(error)
  }

  const { status, data = {} } = error.response
  if (status === 401 && sessionInvalidReasons.includes(data.reason)) {
    return handleSessionInvalid(data)
  } else if (status === 503 && data.reason === 'SESSION_STORE_UNAVAILABLE') {
    handleSessionStoreUnavailable(data)
  }
  return Promise.reject(error)
}

request.interceptors.request.use(config => {
  if (sessionInvalidBarrier) {
    return sessionInvalidBarrier
  }
  const token = storage.get(ACCESS_TOKEN)
  if (token) {
    config.headers['Authorization'] = token
  }
  return config
}, errorHandler)

request.interceptors.response.use(response => {
  if (sessionInvalidBarrier) {
    return sessionInvalidBarrier
  }
  const data = response.data
  if (storage.get(ACCESS_TOKEN)
      && data
      && String(data.code) === '401'
      && sessionInvalidReasons.includes(data.reason)) {
    return handleSessionInvalid(data)
  } else if (storage.get(ACCESS_TOKEN)
      && data
      && String(data.code) === '503'
      && data.reason === 'SESSION_STORE_UNAVAILABLE') {
    handleSessionStoreUnavailable(data)
  }
  return data
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
